import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { MissionStatus } from '../objects/Mission';

angular.module("tromanWeb").factory('reportService', ['$q', 'tromanServer', 'isTroman', function reportServiceFactory($q, tromanServer, isTroman) {

    var reportService = {};
    var cachedReports = null;

    function loadReports() {
        if (cachedReports != null) {
            return $q.when(cachedReports);
        } else {
            return tromanServer.Reports.getReports()
                .then(infos => cachedReports = _.mapKeys(infos, x => x.Id));
        }
    }
    
    const hiddenReportIds = [
        'ConsentLetter',
        'Attestation'
    ];

    reportService.getVisibleReports = function getVisibleReports() {
        return loadReports().then(reports => _.sortBy(_.filter(reports, x => hiddenReportIds.indexOf(x.Id) < 0), ['Identifier']));
    };
    
    const personReportIds = [
        'ConsentLetter',
        'Label_70x36',
        'Equipment',
        'PersonEarnings',
        'PersonAttendance',
        'StatAttendance',
        'PaymentAccumulation',
        'PaymentSummary'
    ];

    reportService.getPersonReports = function getPersonReports() {
        return loadReports().then(reports => personReportIds.map(x => reports[x]).filter(x => x.params.Query.PersonIds));
    };

    reportService.getDefaultArguments = function (report) {
        var ret = angular.copy(report.Defaults);
        var today = utility.todayDate();
        if (report.params.Query.BirthdayFrom)
            ret.Query.BirthdayFrom = new Date(today.getTime());
        if (report.params.Query.BirthdayTo)
            ret.Query.BirthdayTo = new Date(today.getFullYear(), 11, 31);
        if (report.params.Query.AgeFactor)
            ret.Query.AgeFactor = 5;
        if (report.params.Query.OnlyCurrentMandatePeriod)
            ret.Query.OnlyCurrentMandatePeriod = true;
        if (report.params.Query.MissionStatus)
            ret.Query.MissionStatus = MissionStatus.ActiveOrFuture;
        if (report.params.Query.AssociatedMissionStatus)
            ret.Query.AssociatedMissionStatus = MissionStatus.None;
        if (report.params.Query.MeetingDateFrom)
            ret.Query.MeetingDateFrom = new Date(today.getFullYear(), 0, 1);
        if (report.params.Query.IsEquipmentReturned)
            ret.Query.IsEquipmentReturned = false;
        if (report.params.Query.EarningValidToStart)
            ret.Query.EarningValidToStart = new Date(today.getTime());

        if (report.Id === 'Label_70x36') {
            if (report.params.Options.AddressUse)
                ret.Options.AddressUse = 3; // DistributionHome
        } else if (report.Id == 'ConsentLetter') {
            ret.Options.Title = "Samtyckesblankett";
            if (isTroman) {
                ret.Options.LeadText =
                    "I vårt förtroendevaldaregister Troman finns ett antal uppgifter registrerade om dig. " +
                    "I enlighet med gällande lagstiftning och regler upplyser vi dig här vilka uppgifter som finns.\r\n" +
                    "Uppgifterna kan dels användas för presentation på vår hemsida. " +
                    "Men också i de fall som de efterfrågas av allmänheten. " +
                    "Men framförallt är det uppgifter som vi behöver för att kunna komma i kontakt med dig, och för att registrera in uppdrag, historik, med mera.\r\n" +
                    "Kontrollera att uppgifterna stämmer. Fyll gärna på med sådant som saknas. Och slutligen markera de uppgifter som du samtycker att vi publicerar på Internet.";
            } else {
                ret.Options.LeadText =
                    "I vårt valarbetarsystem Valman finns ett antal uppgifter registrerade om dig. " +
                    "I enlighet med gällande lagstiftning och regler upplyser vi dig här vilka uppgifter som finns.\r\n" +
                    "Uppgifterna används för att vi ska kunna komma i kontakt med dig och för att registrera dina arbetspass.\r\n" +
                    "Kontrollera att uppgifterna stämmer. Fyll gärna på med sådant som saknas.";
            }
            ret.Options.UsePersonComment = true;
        }

        return ret;
    };

    reportService.generate = function generate(id, pars) {
        return tromanServer.Reports.generate(id, pars);
    };

    return reportService;
}]);
